import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { withRouter } from 'react-router';
import * as routes from '../constants/routes';
import { Redirect } from 'react-router-dom';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import axios from 'axios';
import * as db from '../db/db';
import moment from 'moment'
import * as statuses from '../constants/requestStatus';
import { AppContext } from "../context/applicationContext";
import ExitToApp from '@material-ui/icons/ExitToApp';
import List from '@material-ui/icons/List';
import Logo from '../assets/LIREX-logo.png';
import * as clients from '../clients';
import Spinner from '../shared/spinner';
import SmallSpinner from '../shared/small-spinner';
import HolidaysTable from '../features/holidaysTable';
const env = process.env.NODE_ENV;
const baseUrl = (process.env.PUBLIC_URL==='/'?'': process.env.PUBLIC_URL) ||'';



const styles = theme => ({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing(2.5),
    },
    paper: {
        marginTop: theme.spacing(3),
        marginBottom: 24,
        padding: 5,
        [theme.breakpoints.up(800 + theme.spacing(3 * 2))]: {
            marginTop: theme.spacing(6),
            marginBottom: theme.spacing(6),
            padding: theme.spacing(3),
        },
        background: 'rgb(255 255 255 / 96%)',
    },
    layout: {
        width: 'auto',
        marginLeft: 5,
        marginRight: 5,
        [theme.breakpoints.up(800 + theme.spacing(1) * 2 * 2)]: {
            width: 800,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    table: {
        minWidth: 300,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    progress: {
        margin: theme.spacing(1) * 2,
        top: '50%!important',
        position: 'absolute'
    },
    buttons: {
        justifyContent: 'flex-end'
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(0),
        width: '100%',
        color: 'white',
        backgroundColor: '#3a3f4b!important',
        justifyContent: 'center'
    }
});
let counter = 0;
function createData(id, title, status, employee, dateFrom, dateTo, siteUrl) {
    counter += 1;
    return { 'id': id, 'title': title, 'status': status, 'employee': employee, 'dateFrom': dateFrom, 'dateTo': dateTo, 'siteUrl': siteUrl };
}

class Holidays extends React.Component {
    static contextType = AppContext;
    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            rows: [],
            page: 0,
            rowsPerPage: 10,
            userSite: null,
            userId: null,
            redirectToEdit: false,
            holidayId: null,
            siteUrl: null,
            progress: false,
            redirectToMyHolidays: false,
            redirectToAddNew: false,
            syncProgress: true,
        };
    }

    componentDidMount() {
        var ua = window.navigator.userAgent;
        var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
        var webkit = !!ua.match(/WebKit/i);
        var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
        var url = this.props.match.url;
        this.context.setStateCustom('redirectFrom', 'allHolidays');
    
        if (!iOSSafari) {
            this.askForNotificationPermission();
        }

        if (this.context.userId !== null && this.context.userId !== undefined) {
            this.setState({ userId: this.context.userId });
            db.idbMethods.get(this.context.userId, db.userInfo).then((userInfo) => {
                this.setState({ userSite: userInfo.userPrimaryCompany.companyURL });
                var userSites = '';
                userSites = userInfo.userPrimaryCompany.companyURL + '*';
                if(userInfo.userSecondaryCompanys){
                userInfo.userSecondaryCompanys.forEach((company, i) => {
                    userSites = userSites + company.companyURL + '*';
                });
               
            }
            this.getHolidaysList(this.context.userId, userSites);
                //Взимане на списък за одобрение от базата
                this.setState({ progress: true });
                var rows = [];
                db.idbMethods.getAll(db.holidaysForApproveList).then((holidays) => {
                    if (holidays[0] !== undefined) {
                        holidays[0].forEach((element, i) => {
                            if (element.Status === statuses.FOR_CONFIRM) {
                                const index = element.Title.indexOf(' №') + 2;
                                const url = element.employeeHolidaySiteURL.split('/');
                                const row = createData(element.Id, element.Title.substr(index), element.Status, element.employeeName, this.formatTime(element.DateFrom), this.formatTime(element.DateTo), url[url.length - 2]);
                                rows.push(row);
                            }
                            if (i === holidays[0].length - 1) {
                                //db.idbMethods.clear(db.holidaysForApproveList);
                                this.setState({ rows: rows });
                                this.setState({ progress: false });
                            }
                        });
                    } else {
                        this.setState({ progress: true });
                    }
                });
            });
        } else {
            this.logOut();
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.context.token;
    }

    getHolidaysList = (id, userSite) => {
        this.setState({ syncProgress: true });
        const link =baseUrl +  '/api/allHolidays';
        axios.post(link, {
            "UserCompanys": userSite,
            "UserId": id,
            "RowLimit": 30
        }, { headers: { 'Authorization': 'Bearer ' + this.context.token } })
            .then(res => {
                if (res.status === 200) {
                    const rows = [];
                    var ids = [];
                    if (res.data !== undefined) {
                        if (res.data !== "") {
                            res.data.forEach((element, i) => {
                                ids.push(element.Id);
                                if (element.Status === statuses.FOR_CONFIRM) {
                                    const index = element.Title.indexOf(' №') + 2;
                                    const url = element.employeeHolidaySiteURL.split('/');
                                    const row = createData(element.Id, element.Title.substr(index), element.Status, element.employeeName, this.formatTime(element.DateFrom), this.formatTime(element.DateTo), url[url.length - 2]);
                                    rows.push(row);
                                }
                                if (i === res.data.length - 1) {
                                    db.idbMethods.clear(db.holidaysForApprove);
                                    db.idbMethods.set(ids, db.holidaysForApprove);
                                    db.idbMethods.clear(db.holidaysForApproveList);
                                    db.idbMethods.set(res.data, db.holidaysForApproveList);
                                }
                            });
                        }
                    }        
                   
                    
                    this.setState({ syncProgress: false });
                    this.setState({ rows: rows });   
                    if(rows.length === 0){
                        this.setState({ redirect: true });
                    };        
                }
               
                this.setState({ progress: false });
            }).catch(error => {
                this.setState({ progress: false });
                this.setState({ redirect: true });
                this.setState({ syncProgress: false });
                console.log(error);
                if (error.response != undefined && error.response.status === 401) {
                    this.logOut();
                }
            })
    }
    askForNotificationPermission = () => {
        if (Notification !== undefined) {
            Notification.requestPermission((result) => {
                if (result !== 'granted') {
                    console.log('No notification permission granted!');
                } else {
                    const isMobile = (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
                    db.idbMethods.getAll(db.subscription).then((sub) => {
                        if (sub === undefined || sub === null || sub.length === 0) {
                            if ("serviceWorker" in navigator) {
                                clients.methods.send('user').then(() => {
                                    db.idbMethods.set(isMobile, db.subscription);
                                }).catch(err => console.log(err));
                            }
                        }else {
                            this.checkForSubsciptions();
                        }
                    }).catch(err => {
                        console.error(err)
                        if ("serviceWorker" in navigator) {
                            clients.methods.send('user').then(() => {
                                db.idbMethods.set(isMobile, db.subscription);
                            }).catch(err => console.log(err));
                        }
                    });
                }
                // this.displayConfirmNotification();
            });
        }
    }

    displayConfirmNotification = () => {
        if ('serviceWorker' in navigator) {
            var options = {
                body: 'Позволени нотификации от Lirex Holidays!',
                icon: '/src/images/icons/app-icon-96x96.png',
                image: '/src/images/sf-boat.jpg',
                dir: 'ltr',
                lang: 'en-US', // BCP 47,
                vibrate: [100, 50, 200],
                badge: '/src/images/icons/app-icon-96x96.png',
                tag: 'confirm-notification',
                renotify: true,
                actions: [
                    { action: 'confirm', title: 'Okay', icon: '/src/images/icons/app-icon-96x96.png' },
                    { action: 'cancel', title: 'Cancel', icon: '/src/images/icons/app-icon-96x96.png' }
                ]
            };

            navigator.serviceWorker.ready
                .then(function (swreg) {
                    swreg.showNotification('', options);
                });
        }
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    redirectToHolidaysList = () => {
        this.setState({ redirect: true });
    }

    openHolidayForEdit = (id, siteUrl) => {
        this.setState({ redirectToEdit: true });
        this.setState({ holidayId: id });
        this.setState({ siteUrl: siteUrl });

    }

    formatTime = (time) => {
        return moment(time).format('DD.MM.YYYY');;
    }

    logOut = () => {
        this.context.setStateCustom('userId', null);
        db.idbMethods.clear(db.userInfo);
        db.idbMethods.clear(db.holidaysForApprove);
        db.idbMethods.clear(db.holidaysForApproveList);
        db.idbMethods.clear(db.myHolidays);
        this.setState({ redirect: true });
    }

    redirectToMyHolidays = () => {
        this.setState({ redirectToMyHolidays: true });
    }

    setRowStyle = (requestType) => {
        switch (requestType) {
            case statuses.REJECTED:
                return 'reject-request';
            case statuses.APPROVE:
                return 'approve-request';
            case statuses.CANCELED:
                return 'canceled-request';
            case statuses.FOR_CONFIRM:
                return 'confirm-first-level';
            case statuses.FOR_CONFIRM_REJECT:
                return 'confirm-reject-first-level';
            default:
                return '';
        }
    }

    addNewrequest = () => {
        this.setState({ redirectToAddNew: true });
    }

    checkForSubsciptions = () => {
        const link = 'api/checkUserSub';
        axios.post(link, { user :{
            "UserCompanys": this.context.userSite,
            "UserId": this.context.userId,
            "RowLimit": 30
        },"type":"user"
        }, { headers: { 'Authorization': 'Bearer ' + this.context.token } })
            .then(res => {
                console.log('hello from fe',res);
                if (res.status === 200) {
                    if (res.data !== undefined && res.data.validSub === false) {
                        db.idbMethods.clear(db.subscription).then(() => {
                        const isMobile = (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
                        if ("serviceWorker" in navigator) {
                            clients.methods.send('user').then(() => {
                                db.idbMethods.set(isMobile, db.subscription);
                            }).catch(err => console.log(err));
                        }
                    });
                    }
                }
            }).catch(error => {
                console.log(error);
            })
    }

    render() {
        const { classes } = this.props;
        const { rows, rowsPerPage, page } = this.state;
        const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
        const appClass = `${classes.appBar} ${this.state.progress ? 'pointer-none' : ''}`;
        const mainClass = `${classes.layout} ${this.state.progress ? 'pointer-none' : ''}`;

        if (this.state.redirect) {
            return <Redirect to={routes.HOME_LOGIN} />
        }
        if (this.state.redirectToMyHolidays) {
            return <Redirect to={routes.MY_HOLIDAYS} />
        }
        if (this.state.redirectToAddNew) {
            return <Redirect to={routes.HOLIDAYS_FORM} />
        }
        if (this.state.redirectToEdit) {
            return <Redirect to={baseUrl +'/holiday/' + this.state.siteUrl + '/' + this.state.holidayId} />
        }
        return (
            <React.Fragment>
                {this.state.progress ? <Spinner></Spinner> : null}
                <CssBaseline />
               
                <main className={mainClass + ' header-mrg'}>
                    <Paper className={classes.paper}>
                    <h4 className='title-custom'>
                    Списък за одобрение
                    </h4>
                        <Typography component="h6" variant="h6" align="center" className="pos-relative">
                            {this.state.syncProgress ? <SmallSpinner></SmallSpinner> : null}
                        </Typography>
                        <Grid item xs={12} sm={12}>
                            <div className={classes.buttons}>
                                <Button
                                    size="small"
                                    variant="contained"
                                    onClick={this.redirectToMyHolidays}
                                    className={classes.button}>
                                    <List className='white-back-button'></List> моите отпуски
                            </Button>
                            </div>
                        </Grid>
                        <div className={classes.tableWrapper}>
                            

                            {rows.length > 0 ?
                        <HolidaysTable list={rows}></HolidaysTable>
                        : null}
                        </div>
                    </Paper>
                </main>
            </React.Fragment>

        )
        // return (
        //     <div className={classes.root}>
        //     <IconButton
        //       onClick={this.handleFirstPageButtonClick}
        //       disabled={page === 0}
        //       aria-label="First Page"
        //     >
        //       {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        //     </IconButton>
        //     <IconButton
        //       onClick={this.handleBackButtonClick}
        //       disabled={page === 0}
        //       aria-label="Previous Page"
        //     >
        //       {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        //     </IconButton>
        //     <IconButton
        //       onClick={this.handleNextButtonClick}
        //       disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        //       aria-label="Next Page"
        //     >
        //       {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        //     </IconButton>
        //     <IconButton
        //       onClick={this.handleLastPageButtonClick}
        //       disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        //       aria-label="Last Page"
        //     >
        //       {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        //     </IconButton>
        //   </div>
        //   );
    }
}

Holidays.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(styles)(Holidays));